import type { DashboardMetric } from "@/services/api/dashboard";
import { fallbackIcons, getToneStyle, iconMap } from "./dashboardUi";

type MetricCardProps = {
  stat: DashboardMetric;
};

export function MetricCard({ stat }: MetricCardProps) {
  const Icon = iconMap[stat.iconName] || fallbackIcons.users;
  const tone = getToneStyle(stat.colorTone);
  const trendClass =
    stat.trendDirection === "up"
      ? "text-green-600"
      : stat.trendDirection === "down"
        ? "text-red-600"
        : "text-slate-500";

  return (
    <div className="flex min-h-[112px] items-center gap-4 rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
      <div
        className={`flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-lg ${tone.soft} ${tone.text}`}
      >
        <Icon size={29} strokeWidth={2.2} />
      </div>
      <div className="min-w-0">
        <p className="m-0 text-sm font-medium text-slate-500">
          {stat.metricTitle}
        </p>
        <p className="mt-1 text-3xl font-bold leading-none text-slate-950">
          {stat.metricValue}
        </p>
        <p className="mt-2 text-xs font-medium text-slate-500">
          <span className={`font-bold ${trendClass}`}>
            {stat.trendDirection} {stat.trendPercentage}
          </span>{" "}
          {stat.comparisonLabel}
        </p>
      </div>
    </div>
  );
}
